var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "eui-panel",
    {
      staticClass: "-kropp-med-overflow-visible",
      class: {
        "-osynlig": _vm.skaVaraOsynlig
      },
      staticStyle: { width: "100%", height: "100%" },
      attrs: {
        "vp-huvud-text": _vm.chartTitle,
        "vp-inaktiverad": _vm.skaVaraInaktiverad,
        disabled: _vm.skaVaraInaktiverad,
        "vp-osynlig": _vm.skaVaraOsynlig,
        "vp-visa-menyfaltet": _vm.vpArIRedigeralage,
        "vp-meny-config": _vm.menyConfig
      },
      on: {
        "update:vpMenyConfig": function($event) {
          _vm.menyConfig = $event
        },
        "update:vp-meny-config": function($event) {
          _vm.menyConfig = $event
        },
        "menyalternativ-valt-i-panel": _vm.onMenyalternativValtIPanel
      }
    },
    [
      _c("eui-multichart", {
        attrs: {
          "vp-widget-settings": _vm.widgetSettings,
          "vp-ar-i-andralage": _vm.arIAndralage,
          "vp-widget-data": _vm.vpWidgetData,
          "vp-force-no-title": true
        },
        on: {
          "update:vpWidgetSettings": function($event) {
            _vm.widgetSettings = $event
          },
          "update:vp-widget-settings": function($event) {
            _vm.widgetSettings = $event
          },
          "update:vpArIAndralage": function($event) {
            _vm.arIAndralage = $event
          },
          "update:vp-ar-i-andralage": function($event) {
            _vm.arIAndralage = $event
          },
          "title-set": _vm.onTitleSet,
          "widget-settings-andrade": _vm.onWidgetSettingsAndrade,
          "klickat-pa-multichart": _vm.onKlickatPaMultichart
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }